import { loadScript, isWechat, isWxWork, isQQ, isWechatMiniProgram } from '@tencent/web-base';
import WechatGetJSSDKToken from "./services/WechatGetJSSDKToken";
const shareInfocb = shareInfo => {
  const shareParams = {
    title: shareInfo.title,
    link: shareInfo.shareUrl,
    imgUrl: shareInfo.imageUrl,
    desc: shareInfo.desc
  };
  window.wx.updateTimelineShareData(shareParams);
  window.wx.updateAppMessageShareData(shareParams);
};
let wxReady = false;
async function initWechatShare(shareInfo) {
  // QQ 内，无 window.wx
  if (!window?.wx || !isWechat(navigator.userAgent)) {
    return;
  }
  if (wxReady && shareInfo) {
    return shareInfocb(shareInfo);
  }
  window.wx.error(res => {
    console.error('wx config error', res);
    window.nextAegis?.error(`[wx config error]: ${JSON.stringify(res)}`);
  });
  window.wx.ready(() => {
    wxReady = true;
    if (shareInfo) {
      shareInfocb(shareInfo);
    }
  });
  const {
    code,
    data
  } = await WechatGetJSSDKToken({
    url: location.href
  });
  if (code === 0 && data) {
    window.wx.config({
      appId: data.app_id,
      // 腾讯会议公众号appid: wxcc5a6312066a11c3
      timestamp: data.sign_time,
      nonceStr: data.sign_noncestr,
      signature: data.sign,
      jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'openLocation']
    });
  }
}
function initQQShare(shareInfo) {
  if (!shareInfo) return;
  const mqqObject = window.mqq;
  if (!mqqObject?.ui?.setOnShareHandler) return;
  mqqObject.ui.setWebViewBehavior({
    actionButton: 1
  });
  mqqObject.ui.setOnShareHandler(type => {
    if (type === undefined) return;
    window.nextAegis?.infoAll(shareInfo, type);
    mqqObject.ui.shareMessage({
      share_url: shareInfo.shareUrl,
      title: shareInfo.title,
      desc: shareInfo.desc,
      image_url: shareInfo.imageUrl,
      sourceName: '腾讯会议',
      puin: '101828163',
      share_type: type,
      back: true
    }, ret => {
      console.error('mqq share error', ret);
      if (typeof window !== 'undefined') window?.nextAegis?.error(`[qq share error]: ${JSON.stringify(ret)}`);
    });
  });
}
/**
 * 按环境加载对应 js
 */
const loadShareJS = async () => {
  if (isWechat(navigator.userAgent) && !window.wx) {
    console.log('>>>>>加载 jwexin.js');
    await loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js').catch(err => {
      if (typeof window !== 'undefined') window?.nextAegis?.error('loadWeixinShareScript error:', err);
    });
  } else if (!isWxWork() && isQQ() && !window.mqq) {
    console.log('>>>>>加载 qqapi.js ');
    await loadScript('https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js');
    await loadScript('https://pub.idqqimg.com/qqmobile/qqapi.js');
  } else if (isWxWork() && !window.wx) {
    await loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js');
  }
  return true;
};

// 过滤表情包
const checkValue = val => {
  if (!val) {
    return '';
  }
  const pattern = /\ud83c[\udc00-\udfff]|\ud83d[\udc00-\udfff]|[\u2000-\u2fff]/g;
  return val.replace(pattern, '');
};

// 对图片压缩
const checkImage = (url, imageWidth = 200) => {
  if (url.includes('/origin?')) {
    const u = new URL(url);
    u.searchParams.set(`imageMogr2/thumbnail/${imageWidth}x`, '');
    return u.toString();
  }
  return url;
};

/** 设置分享文案 */
export const setShareInfo = async shareInfo => {
  if (typeof window === 'undefined') return;
  await loadShareJS();
  if (isWechatMiniProgram() && shareInfo) {
    // 报名页小程序页面拼接
    const nextUrl = `/subWeb?url=${encodeURIComponent(shareInfo?.shareUrl || '')}`;
    const mpRedirectUrl = `/pages/SubWeb/index?type=share&targeturl=${encodeURIComponent(nextUrl)}`;
    const setMiniShare = () => {
      // @ts-ignore
      wx.miniProgram.postMessage({
        data: {
          type: 'share',
          shareData: {
            title: shareInfo?.title,
            shareImageUrl: shareInfo?.imageUrl,
            path: mpRedirectUrl
          }
        }
      });
    };
    setMiniShare();
  }
  if (shareInfo) {
    const checkInfo = {
      ...shareInfo,
      title: checkValue(shareInfo.title),
      desc: checkValue(shareInfo.desc),
      imageUrl: checkImage(shareInfo.imageUrl, 200)
    };
    initWechatShare(checkInfo);
    initQQShare(checkInfo);
  } else {
    initWechatShare();
  }
};